import { createContext } from "react";
const RecaptchaContext = createContext(null);
export {
  RecaptchaContext
};
//# sourceMappingURL=RecaptchaContext.js.map
